import React, { useState } from "react"
import { Container, Header } from "./Shared.styled"
import { ReactComponent as ChevronDown } from "../../../../images/icons/chevron-down.svg"
import { ReactComponent as ChevronUp } from "../../../../images/icons/chevron-up.svg"

import { OrderLine } from "lib/types/generated/graphql-types"
import CartRule from "./CartRule"
import Total from "./Total"
import BundleRule from "./BundleRule"
import Money from "../../../Money"
import DineroFactory from "dinero.js"
import Campaign from "./Campaign"

type Props = {
  orderLine: OrderLine
  currencyUnit: string
}

const CampaignsAndDiscounts = ({ orderLine, currencyUnit }: Props) => {
  const [expanded, setExpanded] = useState(false)

  const cartRules = orderLine?.discountOutcome?.cartRules ?? []
  const bundles = orderLine?.discountOutcome?.bundles ?? []

  if (
    !orderLine?.campaign &&
    cartRules.length === 0 &&
    bundles.length === 0 &&
    (orderLine?.discountOutcome?.totalDiscountAmount ?? 0) === 0
  ) {
    return null
  }

  const productDiscount =
    orderLine.basePriceAmount * orderLine.quantity - orderLine.salePriceAmount * orderLine.quantity

  return (
    <Container>
      <Header onClick={() => setExpanded(!expanded)}>
        <div>{expanded ? <ChevronUp /> : <ChevronDown />} Campaigns and discounts</div>
        {!expanded && (orderLine?.distributedTotalDiscountAmount - productDiscount > 0) && <div>
          -
          <Money
            amount={orderLine?.distributedTotalDiscountAmount - productDiscount}
            currencyUnit={currencyUnit as DineroFactory.Currency}
          />
        </div>}
      </Header>
      {expanded && (
        <>
          {orderLine?.campaign && <Campaign campaign={orderLine?.campaign}/>}
          {orderLine?.discountOutcome?.cartRules?.map((rule) => (
            <CartRule
              key={rule.ruleId}
              currencyUnit={currencyUnit}
              cartRule={rule}
              salePriceAmount={orderLine.salePriceAmount * orderLine.quantity}
            />
          ))}
          {orderLine?.discountOutcome?.bundles?.map((bundle) => (
            <BundleRule
              key={bundle.bundleId}
              bundle={bundle}
              currencyUnit={currencyUnit}
              salePriceAmount={orderLine.salePriceAmount * orderLine.quantity}
            />
          ))}
          <Total
            discountsExclProductDiscount={
              orderLine?.distributedTotalDiscountAmount - productDiscount
            }
            totalDiscount={orderLine?.discountOutcome?.totalDiscountAmount ?? 0}
            salePriceAmount={orderLine?.salePriceAmount * orderLine.quantity}
            currencyCode={currencyUnit}
          />
        </>
      )}
    </Container>
  )
}

export default CampaignsAndDiscounts
